import React from 'react';
import { HeroSectionV2 } from '../components/HeroSectionV2';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV2() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1171">
      <HeroSectionV2 data-id="element-1172" />
      <PainSection data-id="element-1173" />
      <TruthSection data-id="element-1174" />
      <ProductPresentation data-id="element-1175" />
      <ContentBreakdown data-id="element-1176" />
      <BenefitsSection data-id="element-1177" />
      <TestimonialsSection data-id="element-1178" />
      <ForYouSection data-id="element-1179" />
      <GuaranteeSection data-id="element-1180" />
      <BonusSection data-id="element-1181" />
      <ValueStack data-id="element-1182" />
      <FAQSection data-id="element-1183" />
      <ImpactPhrases data-id="element-1184" />
      <Footer data-id="element-1185" />
    </div>;
}